// MIME types for files that can be uploaded to knowledge bases and attachments.
// Copied into backend/api-server/src/lib/mime-types.ts (keep in sync), except
// CR_SUGGESTION_UPLOAD_ACCEPTED_MIME_TYPES, which only the browser uses.

export const TEXT_MIME_TYPES = new Set([
  'text/plain',
  'text/markdown',
  'application/json',
  'application/csv',
  'text/csv',
  'text/tsv',
])

export const PARSEABLE_DOC_MIME_TYPES = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/rtf',
  'text/rtf',
  'application/vnd.oasis.opendocument.text',
])

// Raster images. SVG is not one of them: it is scriptable. CR uploads accept it
// anyway (CR-173) because the parse route sanitizes and rewrites it before the
// storage policy lets anyone but the uploader download it.
export const RASTER_IMAGE_MIME_TYPES = new Set([
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
])

/** CR-173: an SVG upload, sanitized by the parse route before it is readable. */
export const SVG_MIME_TYPE = 'image/svg+xml'

// CR-147: what a CR upload may be. Keep in sync with the cr-uploads bucket's
// allowed_mime_types (backend/supabase/config.toml + 20260922120100 migration).
export const CR_UPLOAD_ACCEPTED_MIME_TYPES: ReadonlySet<string> = new Set([
  ...TEXT_MIME_TYPES,
  ...PARSEABLE_DOC_MIME_TYPES,
  ...RASTER_IMAGE_MIME_TYPES,
  SVG_MIME_TYPE,
])

export const KB_ACCEPTED_MIME_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv',
  'application/csv',
  'text/tsv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/rtf',
  'text/rtf',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint',
  'text/plain',
  'text/markdown',
  'application/json',
  'image/*',
]

// CR-235: what a contributor may attach to a suggestion (images, videos, PDFs;
// no SVG). Keep in sync with the cr-suggestion-uploads bucket's
// allowed_mime_types (backend/supabase/config.toml + 20261021120000 migration).
// Browser-only: the api-server never handles these files, so its copy of this
// module does not carry the set.
export const CR_SUGGESTION_UPLOAD_ACCEPTED_MIME_TYPES: ReadonlySet<string> = new Set([
  ...RASTER_IMAGE_MIME_TYPES,
  'application/pdf',
  'video/mp4',
  'video/webm',
  'video/quicktime',
])
